import { render, staticRenderFns } from "./AllLabelChart.vue?vue&type=template&id=0e3853f4&scoped=true&"
import script from "./AllLabelChart.vue?vue&type=script&lang=js&"
export * from "./AllLabelChart.vue?vue&type=script&lang=js&"
import style0 from "./AllLabelChart.vue?vue&type=style&index=0&id=0e3853f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3853f4",
  null
  
)

export default component.exports